/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/1/14
 * Time: 4:46 PM
 * To change this template use File | Settings | File Templates.
 */


define(function (require) {
    "use strict";

    var LE = require("app");
    var MenuView = require("personalization-views/MenuView");
    var EditView = require("personalization-views/EditView");
    var WA_Config = require("personalization-web-agent-config/config.json");
    var modulesFeaturesConfig = {
        LEWebAgent: require("personalization-web-agent-featuresConfig"),
        LEUserManagement: require("personalization-user-management-featuresConfig")
    };


    var FEATURE_CONTAINER = ".personalization-main-region";
    var CONTROLLER_MODE = {
        ANCHOR: "anchor",
        EDIT: "edit"
    };

    var PersonalizationNavigationController = {};

    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        PersonalizationNavigationController = Marionette.Controller.extend({

            initialize: function (options) {
                this.personalizationModel = options.personalizationModel;
                this._numberOfFeatures = 0;
                this.simulatedEngagementViewActive = false;
                this._featuresConfigList = this._getFeaturesConfigList();
                this.listenTo(this.personalizationModel, "change:isOpen", this._setState, this);
            },

            _getFeaturesConfigList: function () {
                var featuresConfigList = {};
                _.each(modulesFeaturesConfig, function (FeaturesConfig, moduleName) {
                    var conf = new FeaturesConfig(LE);
                    featuresConfigList[moduleName] = {};
                    _.each(conf.pages, function (featuresArr, page) {
                        featuresConfigList[moduleName][page] = {};
                        for (var i = 0; i < featuresArr.length; i++) {
                            if (featuresArr[i].isEnabled() && this._isPermitted(featuresArr[i].permissions)) {
                                featuresConfigList[moduleName][page][featuresArr[i].id] = featuresArr[i];
                                this._numberOfFeatures++;
                            }
                        }
                    }, this);
                }, this);

                return featuresConfigList;
            },
            getNumberOfFeatures: function() {
                return this._numberOfFeatures;
            },
            _isPermitted: function (permissions) {
                var isPermitted = true;
                if(permissions!="*" ){
                    for (var i=0;i<permissions.length;i++){
                        if(!LE.sessionManager.hasPrivilege(permissions[i])){
                            isPermitted = false;
                        }
                    }
                }
                return isPermitted;
            },
            _getFeaturesByModuleAndPage: function (module, page) {
                var features = {};
                if (module && page && this._featuresConfigList[module] && this._featuresConfigList[module][page]) {
                    features = this._featuresConfigList[module][page];
                }
                return features;
            },
            _setState: function (model, isOpen) {
                if (isOpen) {
                    LE.crossModule("connection", LE.media.actions.command, LE.mediaCodes.connection.commands.closeConnectionPanel);
                    this.navigateToPageMenu();
                    LE.context.setDisplayedModule(LEPersonalization.moduleName);
                }
                else {
                    LEPersonalization.getMainView().mainRegion.reset();
                    LE.context.resetDisplayedModule();
                    //the following was previously in IframeIntegrationWidgetAnchorController and IframeIntegrationWidgetEditController
                    //the problem is that these controllers are closed when one of the widget is edited by executing navigateToFeatureEdit()
                    //where it calls the this._closeAllMenuControllers(). Therefore the listener when !isOpen is not fired in these files
                    if (this.simulatedEngagementViewActive){
                        this.simulatedEngagementViewActive = false;
                        LE.crossModule("webagent", LE.media.actions.command, LE.mediaCodes.webAgent.commands.hideSimulatedEngagement);
                    }
                }
                LE.context.set("LEPersonalization.isOpened",isOpen);
            },
            /*
             * options:
             *  module (optional)
             *  page (optional)
             *  featureId (required)
             *  controllerOptions (optional)
             */
            navigateToPageMenu: function (options) {
                options = options || {};
                if (options.page && options.page === WA_Config.SIMULATED_ENGAGEMENT_PAGE){
                    this.simulatedEngagementViewActive = true;
                    LE.crossModule("webagent", LE.media.actions.command, LE.mediaCodes.webAgent.commands.showSimulatedEngagement);
                    LE.vent.once(LE.mediaCodes.webAgent.vent.widgetsAreaVisible, _.bind(function(){
                        this._initAnchorControllers(options);
                    }, this));
                }
                else {
                    this._initAnchorControllers(options);
                }
            },

            _initAnchorControllers: function(options){
                options = options || {};
                this._closeAllMenuControllers();
                var data = this._getPageMenuData(options);

                this.menuControllers=[];
                var isFakePage = false; // indicates that this is not a real page and only runs a callback function
                _.each(data.features, function (feature, id) {
                    data.controllerOptions.featureOptions = feature;
                    var anchorController = new feature.anchorController(data.controllerOptions);
                    this.menuControllers.push(anchorController);

                    isFakePage = this._handleFakePage(anchorController);
                    if (isFakePage) {
                        return false;
                    }
                    else if (_.isFunction(anchorController.getAnchorView)){
                        var anchorView = anchorController.getAnchorView({
                            anchorSelector: feature.anchorSelector,
                            featureId:id
                        });
                        data.viewsMap[id] = anchorView;
                        data.menuCollection.add(new data.AnchorModel({"featureId":id}));
                    }
                },this);
                this._renderMenuView(isFakePage, data.menuCollection, data.viewsMap);
            },

            _getPageMenuData: function(options) {
                options = options || {};
                var dataObj = _.extend({}, this._getPageAndModule(options));
                dataObj.features = this._getFeaturesByModuleAndPage(dataObj.module, dataObj.page);
                dataObj.menuCollection = new Backbone.Collection();
                dataObj.AnchorModel = Backbone.Model;
                dataObj.viewsMap = {};

                dataObj.controllerOptions = {
                    mode: CONTROLLER_MODE.ANCHOR,
                    module: dataObj.module,
                    page: dataObj.page
                };
                if(options.controllerOptions){
                    _.extend(dataObj.controllerOptions, options.controllerOptions);
                }

                return dataObj;
            },

            _handleFakePage: function(anchorController) {
                var isFakePage = false;

                if (_.isFunction(anchorController.getFakePageCallback)) {
                    var callback = anchorController.getFakePageCallback();
                    callback();
                    isFakePage = true;
                }

                return isFakePage;
            },

            _renderMenuView: function(isFakePage, menuCollection, viewsMap) {
                if (!isFakePage) {
                    var menuView = new MenuView({
                        collection:menuCollection,
                        viewsMap:viewsMap
                    });

                    this._bindEventsOnMenuView(menuView);

                    LEPersonalization.getMainView().mainRegion.show(menuView);
                }
            },

            _bindEventsOnMenuView: function(view) {
                this.listenTo(view, "render", function() {
                    LE.DomEvents.on("keyup", "personalizationMenuView", LEPersonalization.moduleName, LE.context, _.bind(this._handleKeyupOnMenuView, this));
                });

                this.listenTo(view, "close", function() {
                    LE.DomEvents.off("keyup", "personalizationMenuView");
                });
            },

            _handleKeyupOnMenuView: function(e) {
                var key = e.keyCode;
                if (key === $.ui.keyCode.ESCAPE) {
                    this.personalizationModel.set("isOpen", false);
                }
            },

            /*
            * options:
             *  module (optional)
             *  page (optional)
             *  featureId (required)
             *  controllerOptions (optional)*/
            navigateToFeatureEdit: function (options) {
                options = options || {};
                this._closeAllMenuControllers();
                var data = this._getFeatureEditData(options);

                if (this._featuresConfigList[data.module] && this._featuresConfigList[data.module][data.page] && this._featuresConfigList[data.module][data.page][data.featureId]) {
                    var feature = this._featuresConfigList[data.module][data.page][data.featureId];
                    data.controllerOptions.featureOptions = feature;
                    this.activeEditController =  new feature.editController(data.controllerOptions);
                    if (_.isFunction(this.activeEditController.getEditView)) {
                        var editFeatureView = this.activeEditController.getEditView({
                            anchorSelector: feature.anchorSelector
                        });

                        this._bindEventsOnFeaturesView(editFeatureView);

                        LEPersonalization.getMainView().mainRegion.show(editFeatureView);
                    }
                }
            },

            _getFeatureEditData: function(options) {
                options = options || {};
                var dataObj = _.extend({}, this._getPageAndModule(options));
                dataObj.featureId = options.featureId;

                dataObj.controllerOptions = {
                    mode: CONTROLLER_MODE.EDIT,
                    module: dataObj.module,
                    page: dataObj.page,
                    featureId: dataObj.featureId,
                    container: FEATURE_CONTAINER
                };
                if(options.controllerOptions){
                    _.extend(dataObj.controllerOptions, options.controllerOptions);
                }

                return dataObj;
            },

            _bindEventsOnFeaturesView: function(view) {
                this.listenTo(view, "render", function() {
                    LE.DomEvents.on("keyup", "personalizationFeatureView", LEPersonalization.moduleName, LE.context, _.bind(this._handleKeyupOnFeatureView, this));
                });

                this.listenTo(view, "close", function() {
                    LE.DomEvents.off("keyup", "personalizationFeatureView");
                });
            },

            _handleKeyupOnFeatureView: function(e) {
                var key = e.keyCode;
                if (key === $.ui.keyCode.ESCAPE) {
                    LEPersonalization.navigateToPageMenu();
                }
            },

            getFeaturesByRoutCount:function(options){
                options = options ||{};
                var module = LE.context.get("activeModuleName");
                var page = options.page || this.personalizationModel.get("page");
                var features = this._getFeaturesByModuleAndPage(module,page);
                return _.keys(features).length;
            },

            _getPageAndModule: function(options) {
                return {
                    module: options.module || LE.context.get("activeModuleName"),
                    page: options.page || this.personalizationModel.get("page")
                };
            },

            _closeAllMenuControllers:function(){
                if(this.menuControllers){
                    for(var i=0;i<this.menuControllers.length;i++){
                        if(this.menuControllers[i].close){
                            this.menuControllers[i].close();
                        }
                    }
                }
                this.menuControllers=[];
            }

        });
    });
    return PersonalizationNavigationController;

});
